<template>
  <Viewer
      @inited="inited"
      ref="viewer"
  >
    <div class="grid grid-cols-12 gap-6 rtl:dir-rtl">
      <div class="col-start-1 col-end-13 md:col-end-5">
        <Card>
          <ul class="list space-y-8">
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.firstName.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ applicantBasicInformation.firstName }}
                </div>
              </div>
            </li>
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.lastName.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ applicantBasicInformation.lastName }}
                </div>
              </div>
            </li>
            <!-- end single list -->
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="heroicons:phone"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.username.label') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ applicantBasicInformation.username }}
                </div>
              </div>
            </li>
            <!-- end single list -->
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="heroicons:map"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.verification state') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ applicantBasicInformation.verificationState }}
                </div>
              </div>
            </li>
            <!-- end single list -->
          </ul>
        </Card>
      </div>
      <div class="col-start-1 col-end-13 md:col-start-5 md:col-end-9">
        <Card>
          <ul class="list space-y-8">
            <li class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.balance') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ applicantBasicInformation.balance }}
                </div>
              </div>
            </li>
            <li v-if="applicantBasicInformation.lastUpdate" class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.last update') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ convertTimestamp(applicantBasicInformation.lastUpdate) }}
                </div>
              </div>
            </li>
            <li v-if="applicantBasicInformation.registrationTime" class="flex space-x-3 rtl:space-x-reverse">
              <div
                  class="flex-none text-2xl text-slate-600 dark:text-slate-300"
              >
                <Icon icon="streamline:information-desk"/>
              </div>
              <div class="flex-1 rtl:text-right">
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 mb-1 leading-[12px]"
                >
                  {{ $t('message.registration time') }}
                </div>
                <div class="text-base text-slate-600 dark:text-slate-50">
                  {{ convertTimestamp(applicantBasicInformation.registrationTime) }}
                </div>
              </div>
            </li>
          </ul>
        </Card>
      </div>
      <div class="col-start-1 col-end-13 md:col-start-9">
        <Card>
          <div class="flex flex-col gap-6">
            <div class="flex flex-col text-2xl text-slate-600 dark:text-slate-300 gap-2">
              <div class="flex flex-row items-center gap-3">
                <Icon icon="uil:selfie"/>
                <div
                    class="uppercase text-xs text-slate-500 dark:text-slate-300 leading-[12px]"
                >
                  {{ $t('message.selfie.label') }}
                </div>
              </div>
              <div class="flex-1 rtl:text-right"
                   v-if="applicantBasicInformation.kycSelfie && getFileExtension(applicantBasicInformation.kycSelfie.link) === 'pdf'">
                <iframe :src="applicantBasicInformation.kycSelfie.link" class="h-full w-full"></iframe>
                <a :href="applicantBasicInformation.kycSelfie.link" target="_blank"
                   class="text-sm text-primary-500 mt-2">
                  Download
                </a>
              </div>
              <div v-else class="flex-1 rtl:text-right" @click="show">
                <!--                    <Image
                                        :src="applicantBasicInformation.kycSelfie.link"
                                        :alt="$t('message.selfie.label')"
                                        imageClass="rounded-md border-4 border-slate-300"
                                    />-->
                <VueMagnifier v-if="applicantBasicInformation.kycSelfie" :src="applicantBasicInformation.kycSelfie.link"
                              class="rounded-md border-4 border-slate-300"/>
                <a v-if="applicantBasicInformation.kycSelfie" :href="applicantBasicInformation.kycSelfie.link"
                   target="_blank"
                   class="text-sm text-primary-500 mt-2">
                  Download
                </a>
              </div>
            </div>
          </div>
        </Card>
      </div>
    </div>
  </Viewer>
</template>
<script setup>
import Icon from "@/components/Icon/index.vue";
import Card from "@/components/Card/index.vue";
import Textarea from "@/components/Textarea/index.vue";
import Image from '@/components/Image/index.vue';
import 'viewerjs/dist/viewer.css';
import {component as Viewer} from 'v-viewer';
import VueMagnifier from '@websitebeaver/vue-magnifier'
import '@websitebeaver/vue-magnifier/styles.css'
import jalaliMoment from "jalali-moment";
import {useI18n} from "vue-i18n";

const {t, locale} = useI18n({useScope: 'global'})
let $viewer = null;
const inited = (viewer) => {
  $viewer = viewer;
};
const show = () => {
  if ($viewer) {
    $viewer.show(); // Opens the viewer at the specified index
  }
};

const props = defineProps({
  applicantBasicInformation: Object
});

function convertTimestamp(timestamp) {
  const date = new Date(timestamp);
  const jalaliDate = jalaliMoment(date);
  if (locale.value === "fa") {
    return jalaliDate.locale('fa').format('jYYYY/jMM/jDD')
  } else {
    return date.toLocaleDateString();
  }
}
</script>
<style scoped lang="scss">

</style>